module.exports = __webpack_public_path__ + "static/media/visual_recs_onboarding_welcome.d3b72f54.png";